import styles from './LoadingTip.module.css'

interface LoadingTipProps {
  tip: string
}

export function LoadingTip({tip}: LoadingTipProps) {
  return (
    <div className={styles.tipContainer}>
      <span aria-hidden="true">💡</span>
      <span className={styles.tipLabel}>Tip</span>
      <span className={styles.tipText}>{tip}</span>
    </div>
  )
}
